import React, { useContext, useMemo } from "react";
import { CommandBarButton } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";
import { OrderListingContext } from "../context/OrderListingContext";
import { OrderListingItem } from "../OrderListingItem";

export const PinOrderButton: React.VFC = () => {
    const { selectedItems, togglePinnedOrder } = useContext(OrderListingContext);
    const allArePinned = useMemo(() => selectedItems.every((item) => item.isPinned), [selectedItems]);

    const handlePinOrders = () => {
        if (allArePinned) {
            pinSelectedOrders(selectedItems);
        } else {
            const unpinnedItems = selectedItems.filter((item) => !item.isPinned);
            pinSelectedOrders(unpinnedItems);
        }
    };

    const pinSelectedOrders = (orders: OrderListingItem[]) => {
        orders.forEach((item) => togglePinnedOrder(item.id));
    };

    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.OrdReadWrite]}>
            <CommandBarButton
                text={allArePinned ? "Unpin" : "Pin"}
                icon="Pinned"
                disabled={!selectedItems.length}
                onClick={handlePinOrders}
            />
        </AuthorizationWrapper>
    );
};
